import { render, staticRenderFns } from "./CouponRegistration.vue?vue&type=template&id=22c95910&scoped=true&"
import script from "./CouponRegistration.vue?vue&type=script&lang=js&"
export * from "./CouponRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CouponRegistration.vue?vue&type=style&index=0&id=22c95910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c95910",
  null
  
)

export default component.exports